window.lp.ModuleComponent = {
  getModule: function() {
    return window.lp.getModule(this.type);
  }
};



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/module_component.js
// module id = 421
// module chunks = 0 1